import * as React from 'react';
import Modal from '@mui/material/Modal';

const BasicModal = ({ open, setOpen, children, blockClosingFeature }) => {
	// console.log('Content is : ', content);
	if (!children) return <></>;
	return (
		<Modal
			open={open}
			onClose={() => {
				if (!blockClosingFeature) setOpen(false);
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			className="modal"
		>
			{children}
		</Modal>
	);
};

export default BasicModal;
